import axios from "axios";
import { Cookies } from "react-cookie";

const API_URL = process.env.REACT_APP_API_URL;
let sessionExpiredHandled = false;

class BaseApi {
	API = async (options) => {
		const cookies = new Cookies();
		const token = cookies.get('PDATokenStage') || null;
		const authHeader = token ? `Bearer ${token}` : '';

		const client = axios.create({
			baseURL: API_URL,
			headers: {
				"Content-Type": "application/json",
				"Accept": "*/*",
				"authorization": authHeader
			},
		});
		return client(options)
			.then((response) => {
				return response.data;
			})
			.catch((error) => {
				console.log("baseapi error ...", error);
				if (error.response && error.response.status === 401) {
					if (!sessionExpiredHandled && window.location.pathname !== "/login") {
						sessionExpiredHandled = true;
						console.log("[baseApi] 401 session expired, clearing auth and redirecting to login");
						cookies.remove('PDATokenStage');
						cookies.remove('PDAUserStage');
						// Clear MSAL cache (localStorage + cookies) so next Azure sign-in doesn't hit hash_empty_error
						try {
							Object.keys(localStorage).filter(k => k.startsWith('msal.')).forEach(k => localStorage.removeItem(k));
							// MSAL also uses cookies when storeAuthStateInCookie: true
							document.cookie.split(';').forEach(c => {
								const name = c.trim().split('=')[0];
								if (name && name.startsWith('msal.')) {
									document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
								}
							});
						} catch (_) { /* ignore */ }
						alert("Your session has expired. Please log in again.");
						window.location.href = "/login";
						// Don't rethrow Axios error — we're redirecting; avoids console noise and unhandled rejection
						return Promise.reject(new Error('Session expired'));
					}
				}
				throw error;
			});
	}
}

export default BaseApi;